import TransferFunds from './TransferFunds';
import NewBeneficiary from './NewBeneficiary';
import SavedBeneficiary from './SavedBeneficiary';
import TransferFundOptions from './TransferFundOptions';
import TransferPinConfirm from '../TransferPinConfirm';

export {
	TransferFunds,
	NewBeneficiary,
	SavedBeneficiary,
	TransferFundOptions,
	TransferPinConfirm,
};
